






















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { CostCentre } from '@/models/cost-centre';

@Component({
    name: 'costcentre-selector',
})
export default class CostcentreSelector extends Vue {
    public costcentreId: string | null = null;
    @Prop({ required: true }) public availableCostcentres: Array<CostCentre>;

    public get selectedCostcentre(): CostCentre | null {
        if (this.costcentreId === null || this.costcentreId === undefined) {
            return null;
        }

        return this.availableCostcentres.find(c => c.id === this.costcentreId!)!;
    }

    public get hasChildren(): boolean {
        return this.selectedCostcentre !== null &&
            this.selectedCostcentre !== undefined &&
            this.selectedCostcentre!.children!.length > 0;
    }

    public get costCentresToDisplay() : Array<CostCentre> {
        return this.availableCostcentres;
    }

    public get costcentreChildren() : Array<CostCentre> {
        if (this.selectedCostcentre === null || this.selectedCostcentre === undefined) {
            return [];
        }

        if (this.selectedCostcentre!.children === null || this.selectedCostcentre!.children!.length === 0) {
            return [];
        }

        return this.selectedCostcentre!.children!;
    }

    @Watch('costcentreId')
    public async onCostcentreChanged(value: string | null): Promise<void> {
        this.$emit('costcentre-selected', value);
    }

    public onCostcentreSelected(costCentreId: string | null): void {
        this.$emit('costcentre-selected', costCentreId);
    }
}
